import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../utils/api';

export default function Billing() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const createCheckoutSession = async () => {
      // Get the signup data and selected plan from navigation state
      if (location.state?.signupData && location.state?.selectedPlan) {
        const userData = location.state.signupData;
        const planName = location.state.selectedPlan;

        try {
          const response = await api.post<{url: string, sessionId: string}>('/api/stripe/create-signup-checkout-session', {
            email: userData.email,
            name: userData.name,
            companyName: userData.companyName,
            planName,
            signupData: userData
          });
          
          // Redirect to Stripe Checkout hosted page
          if (response.data?.url) {
            window.location.href = response.data.url;
          }
        } catch (error) {
          console.error('Failed to create checkout session:', error);
          navigate('/signup');
        }
      } else {
        // If no data, redirect back to signup
        navigate('/signup');
      }
    };

    createCheckoutSession();
  }, [location.state, navigate]);

  // Show loading while redirecting to Stripe Checkout
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
        <div className="text-white text-lg">Redirecting to secure payment...</div>
      </div>
    </div>
  );
}
